import React from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../Footer';
import ContattiForm from './contact_form';
import TagComponent from '../tags/index';
import './style.css';

const Contact = () => {
    const { servizioID } = useParams();
    return (
			<section
				className="paralax-mf footer-paralax bg-image route secBack"
			>
				<ContattiForm />

				<TagComponent />
				
				<Footer />

			</section>
		);
}

export default Contact;
